<template>
  <div class="elabel-editor">
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <div class="d-flex align-center pt-5 pb-3">
      <v-btn @click="handleBackNav" class="ml-3" icon><v-icon color="black">mdi-arrow-left</v-icon></v-btn>
      <div class="page-title mono pl-3">{{$t('elabel_management_tool')}}</div>
      <v-spacer></v-spacer>
    </div>
    <iframe id="elabel-editor-frame" v-if="loadIframe" frameborder="0" :src="this.editorUrl"></iframe>
  </div>
</template>

<script>

import Api from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'LandingPage',
  computed: {
    ...mapGetters(['scantrustAuthToken', 'didProductUpdate'])
  },
  watch: {
    '$route.params.id' (newVal) {
      if (newVal) {
        if (document.getElementById('elabel-editor-frame')) {
          this.editorUrl = Api.elabel_editor_url + '#/edit/' + this.$route.params.id + '/form?&token=' + this.scantrustAuthToken
          this.loadIframe = false
          this.$nextTick(() => {
            this.loadIframe = true
          })
        }
      }
    }
  },
  data () {
    return {
      previousRouteName: '',
      loadIframe: true,
      config: {},
      campaign: {},
      loading: true,
      editorUrl: ''
    }
  },
  methods: {
    initEventHandler () {
      var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
      var eventer = window[eventMethod]
      var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'

      eventer(messageEvent, (e) => {
        if (e.data.type === 'editor.loaded') {
          this.loading = false
        } else if (e.data.type === 'editor.navigation') {
          if (~e.data.hash.indexOf('#')) {
            this.$router.push(e.data.hash.split('#')[1])
          }
        }
      })
    },
    handleBackNav () {
      if (this.previousRouteName === 'products') {
        this.$router.push({ name: 'products' })
      } else if (this.previousRouteName === 'products.codes') {
        this.$router.push({ name: 'products.codes', params: { id: this.$route.params.id } })
      } else {
        this.$router.push({ name: 'products' })
      }
    }
  },
  async created () {
    this.editorUrl = Api.elabel_editor_url + '#/edit/' + this.$route.params.id + '/form?&token=' + this.scantrustAuthToken
    this.initEventHandler()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousRouteName = from.name || 'products'
    })
  },
  beforeRouteLeave (to, from, next) {
    // Handles navigating from e-label editor back to products list in QR manager when there are unsaved changes in editor
    const editorFrame = document.getElementById('elabel-editor-frame')
    if (!editorFrame) {
      next()
      return
    }

    const timeout = setTimeout(() => {
      window.removeEventListener('message', onMessage)
      next()
    }, 5000)

    const onMessage = (evt) => {
      if (evt.data.type === 'editor.leavePrompted') {
        // Editor is showing its unsaved-changes modal; cancel the fallback and wait for the user's decision
        clearTimeout(timeout)
        return
      }
      if (evt.data.type === 'editor.readyToLeave' || evt.data.type === 'editor.cancelLeave') {
        window.removeEventListener('message', onMessage)
        clearTimeout(timeout)
        next(evt.data.type === 'editor.readyToLeave')
      }
    }

    window.addEventListener('message', onMessage)
    editorFrame.contentWindow.postMessage({ type: 'editor.beforeNavigate' }, '*')
  }
}

</script>

<style lang="sass" scoped>

.elabel-editor
  font-family: 'Roboto mono'
  height: 100%
  width: 100%

iframe
  overflow: hidden
  width: 100%
  height: 100%
  min-width: 100%
  min-height: 100%
</style>
